module.exports = __webpack_public_path__ + "static/media/food_beach_2.53b0c59e.svg";